import AssociateDashboardShell from './associateDashboard/AssociateDashboardShell';
import PromotionSummary from './associateDashboard/PromotionSummary';
import { getRoleTokenSettings } from '../auth/apiRoleTokens';
import { resolveAssociateNavigation, associateSearch } from './associateNavigation';
import RoleTokenOwnerPanel from './roleTokens/RoleTokenOwnerPanel';
import { tokenText } from './roleTokens/tokenText';
import React, { useState, useRef, useEffect, useCallback} from 'react';
import {QRCodeCanvas} from 'qrcode.react';
import {useLocation, useNavigate, Link} from "react-router-dom";
import Layout from "../Layout/Layout";
import Form from 'react-bootstrap/Form'
import AdminFamily from "../pages/addAdminFamily"
import {addUpdateGraphicPromo, getAllGraphicPromo, creatTokenPUB, deleteUserPubById, isAuthenticated, AllMyUserReF, getElakayIncomme} from "../auth";
import {
    elakayFraisJSON,
    ItemsOrder,
    getTotal,
    inComeSeller,
    prodFrTransaction,
    elakayFrais,
    totalFrais,
    calProfit
} from '../auth/allPriceFeet';
import Associateincomedashboard, { MyPromotionOrdersTable, styles as associateIncomeStyles } from "../pageInside/Associateincomedashboard.jsx";
import useDebouncedValue from "../pageInside/hooks/useDebouncedValue";
import { ELAKAY_SITE_URL } from "../../config"
import CardUSer from "../pageInside/cardUser"
import FilterUserTeam from "../pageInside/filterUserTeam"
import SearchBar from '../pageInside/admin_associate_searchBar';
import ShopUserView from "./lakayUser/ShopUser";
import Modal from 'react-bootstrap/Modal'
import { Row } from 'react-bootstrap';
import AlertPage from '../pageInside/alertPage';
import "./admin_associate.css";
import "./associateDashboard/associateDashboard.css";
import { prices } from "../pageInside/fixedPrices";
import BusinessCard from '../pageInside/businessCard';
import { FaUser,  FaStore, FaUsersBetweenLines} from "react-icons/fa6";
import { AiFillProduct } from "react-icons/ai";
import { FaHome, FaGift, FaUserPlus, FaUsers, FaWallet, FaReceipt } from "react-icons/fa";
import Filter_searchProductUser from '../pageInside/filter_searchProductUser';
import UserExitActAss from "../pages/userPageExiste/actPageAssUserExit";
import { Family, Adminstrator, Investment, Assoociate, Seller} from "../pageInside/Rolle"
import AdminSlotTable from "../pageInside/adminSlotTable";
import ButtonPagination from "../pageInside/ButtonPagination";
import PaginationInfo from "../pageInside/paginationInfo"
import ImageCombiner from '../pageInside/imageCombiner';
import QrCodeDesigner from '../pageInside/qrDesigner/QrCodeDesigner';
import { listQrDesigns, qrDesignImageUrl } from '../auth/apiQrDesigns';
import BusinessCardCreator from '../pageInside/Businesscardcreator';
import { elakay_API } from "../../config";
import { elakayAutoText } from "../pageInside/dataElakay";
import AssociateRoleRequests from "./AssociateRoleRequests";
import CommunityLive from "./live/CommunityLive";
import { FaBroadcastTower } from "react-icons/fa";
import GroupInvitationsAdmin from "./groupInvitations/GroupInvitationsAdmin";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["adminassociate"]?.[key] || fallback;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const walletIncomeFilters = {
  roneName: ["Family", "Administrator", "Investment", "Associate", "Provider", "Seller", "Royalty"],
  orderStatus: ["Not processed", "Processing", "Shipped", "Delivered", "Cancelled", "Return Back"],
  OrdersReadyToPay: false,
  orderDate: 'months',
  limit: "Endless",
  myd: 6,
  asc: 'desc'
}

const Admin_associate = (props) => {
const { infoSource } = props
__setElakayInfoSource(infoSource);
const usePaymentIntentIncome =
  infoSource?.allSettings?.wallet?.usePaymentIntentIncome === true;

const {
  readUser,
  userRole,
  userInfo
} = infoSource

  const navigate = useNavigate();
  const navigation = resolveAssociateNavigation(useLocation().search, Family());
  const location = useLocation(); // Surveille les changements d'URL
  const query = useQuery();
  const getPageBoo = () => {
     
    const page = navigation.tab === 'introduction' ? '' : navigation.tab;
    const usel = query.get("usel") || 0
    return {
      page,
      usel
    }
};

const filterlist =  {
  asc: 'asc',
  limit : 10,
  skip : 0,
  roleName: 'null',
  allUser: false,
  myUser: false,
  grpByrole : false,
  agr: 1,
  sortBy: 'createdAt',
  userID: '',
  search: ''
  ,pointsMode: ''
  ,minPoints: ''
  ,maxPoints: ''
  ,suspensionStatus: ''
  ,scopeMode: Family() ? 'all' : 'team'
}

    const [selectRole, setSelectRole] = useState(Number(getPageBoo().usel));
    const [graphicList, setGraphicList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [userTeam, setUseTeam] = useState([])
    const[nbrDays, setNbrDays] = useState(1)
    const [qrDuration, setQrDuration] = useState(365); // défaut = 1 an
    const { token } = isAuthenticated();
    const [showFilterOurTeam, setSowFilterOurTeam] = useState(false)
    const [showPromoUsPr, setSowPromoUsPr] = useState(false)
    const [showTable, setShowTable] = useState(false);
    const [pagePromoUsPr, setpagePromoUsPr] = useState({
      user_id: null,
      prod_id: null    
    })
    const [refShopName, setRefShopName] = useState('')
    const [title, setTitle] = useState(refShopName)
    // Simple Promotion / Seller Promotion Token / Provider Promotion Token —
    // single-select, only applies to the regular Promotion list (Carte 1),
    // never to the "My QR Code" singleton (MyQRcodetoken_/MyQRcodetoken).
    const [promotionType, setPromotionType] = useState("simple")
    const [promotionMaximum, setPromotionMaximum] = useState('');
    const [promotionLimits, setPromotionLimits] = useState(null);
    const [getFilterOurTeam, setFilterOurTeam]= useState(filterlist)
    const [url, setUrl] = useState(ELAKAY_SITE_URL);
    const [promoInfo, setPromoInfo] = useState({});
   const imageRef = useRef();
   const prevSearchRef = useRef(location.search);
   const [showConditionsRole, setConditionsRole] = useState(false);
   const [getFullName, setFullName] = useState(null)
   const [getRolaName, setRoleName] = useState(null)
   const [pageTeam, setPageTeam]=useState(true)
   const [pageProd, setPageProd]=useState(false)
    const[filterShop, setFilterShop] = useState(false)
    const [getCalFilShop, setCalFilShop] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [messagetext, setMessagetext]= useState(null)
   const [pageShop, setPageShop]=useState(false)

   const [selectedPromoId, setSelectedPromoId] = useState("");
   // QR Code Designer designs offered by the Poster Creator ("Insert QR Code").
   const [designedQrs, setDesignedQrs] = useState([]);
const navigateTab = tab => navigate({ pathname: location.pathname, search: associateSearch(location.search, tab) });
const navigateView = view => navigate({ pathname: location.pathname, search: associateSearch(location.search, 'elakayPromo', view) });
const [getPubToken, setPubToken] = useState([]);

const [my_Order_as_Seller, setMy_Order_as_Seller] = useState([]);
const [my_Seller_Order, setMy_Seller_Order] = useState([]);
const [my_Commision_Orders, setMy_Commision_Orders] = useState({});
const [my_Promo_Orders, setMy_Promo_Orders] = useState({});
const [incommeView, setIncommeView] = useState("MyOrdersAsSeller");
const [filtOrders, setFiltOrders] = useState(walletIncomeFilters);

const handleChartDateRangeChange = useCallback((dateRange) => {
    setFiltOrders((current) => {
        const next = { ...current, ...dateRange, limit: "Endless" };
        return JSON.stringify(current) === JSON.stringify(next) ? current : next;
    });
}, []);

       const [myFilters, setMyFilters] = useState({
               filters: {"categoriesID.gategoriesLink": [] }
           });
           const {
            search
           } = getFilterOurTeam
           // The team search input updates getFilterOurTeam.search on every
           // keystroke (admin_associate_searchBar.jsx) — debounce what
           // actually triggers the AllMyUserReF refetch below instead of
           // firing it once per keystroke.
           const debouncedSearch = useDebouncedValue(search, 300)

  const divUSserTeam = useRef(null);
  const divContent = useRef(null);
// scrollToParagraph(divContent)
const scrollToParagraph = (ref) => {
         if (ref && ref.current) {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  }
      };

useEffect(() => {
  const currentSearch = location.search;

  if (prevSearchRef.current !== currentSearch) {
    setSelectRole(Number(getPageBoo().usel))
      prevSearchRef.current = currentSearch; // Met à jour la valeur précédente
  }
  loadAllMyUserRef(getFilterOurTeam)


}, [location.search, debouncedSearch, navigation.tab, navigation.view]);

// Never leave a disabled Promotion Type silently selected -- if Family
// turns it off while this page is open (or it loads already disabled),
// fall back to Simple Promotion (always available by default).
useEffect(() => {
  let active = true;
  const refresh = () => getRoleTokenSettings(token).then(data => { if (active) setPromotionLimits(data.settings); }).catch(() => {});
  refresh();
  window.addEventListener('focus', refresh);
  return () => { active = false; window.removeEventListener('focus', refresh); };
}, [token]);
useEffect(() => { setPromotionMaximum(''); }, [promotionType]);
const requestedPromotionMaximum = Number(promotionMaximum || promotionLimits?.[`${promotionType}MaximumUsers`]);
const promotionMaximumInvalid = promotionType !== 'simple' && (!Number.isSafeInteger(requestedPromotionMaximum) || requestedPromotionMaximum < 1 || requestedPromotionMaximum > promotionLimits?.[`${promotionType}MaximumUsers`]);

useEffect(() => {
  const enabledKey = {
    simple: "simplePromotionEnabled",
    seller: "sellerPromotionEnabled",
    provider: "providerPromotionEnabled",
  }[promotionType];
  const isTypeEnabled = infoSource?.allSettings?.promotionTokenSettings?.[enabledKey] !== false;
  if (!isTypeEnabled) setPromotionType("simple");
}, [promotionType, infoSource?.allSettings?.promotionTokenSettings]);

// "Insert QR Code" in the Poster Creator: the user's saved QR designs,
// inserted as they were designed (their link travels with them).
useEffect(() => {
  if (navigation.view !== 'poster' || navigation.tab !== 'elakayPromo' || !token) return undefined;
  let active = true;
  listQrDesigns()
    .then(data => {
      if (!active) return;
      setDesignedQrs((data.designs || []).map(design => ({
        id: `qrd_${design._id}`,
        label: design.name,
        value: design.link,
        url: qrDesignImageUrl(design),
        qrUrl: qrDesignImageUrl(design),
        designed: true,
      })));
    })
    .catch(() => { if (active) setDesignedQrs([]); });
  return () => { active = false; };
}, [navigation.view, navigation.tab, token]);

useEffect(() => {
  if (!infoSource?.getPubToken) return;
  if (!token) return;
  const { getProm } = getMyQRCodePromo();

  if (getProm?.token) {
    setMyQRCodeState();
  }
  getAllGraphicPromo(token).then(data => {
    if (data?.success) {
      setGraphicList(data.result);
    }
  });

}, []);

useEffect(() => {
  if (!token) return;
  // Data loading is keyed on the real account (token), never on the selected
  // Switch Role: the server scopes this to the caller's own orders/income.
  getElakayIncomme(token, 0, filtOrders, usePaymentIntentIncome).then(response => {
    const data = response?.data || response;
    if (data?.error) return;
    setMy_Order_as_Seller(data?.My_Order_as_Seller || data?.data?.mySellerOrders || []);
    setMy_Seller_Order(data?.My_Seller_Order || data?.data?.myReferrerSellerOrders || []);
    setMy_Commision_Orders(data?.My_Order_incomme || {});
    setMy_Promo_Orders(data?.My_Promo || {});
  });
}, [token, filtOrders, usePaymentIntentIncome]);

const getValidId = (id1, id2) => {
  // Vérifie si id1 est vide, null, undefined, ou une chaîne vide
  if (!id1) {
      return id2;
  }
  return id1;
}

  const handlePrice = value => {
 
         let array = [];
         for (let key in prices) {
             if (prices[key]._id === parseInt(value)) {
                 array = prices[key].array;
             }}
         return array;
     };
 
     const handleFilters = (filters, filterBy) => {
         const newFilters = { ...myFilters };
         newFilters.filters[filterBy] = filters;
 
         if (filterBy === "price") {
             let priceValues = handlePrice(filters);
             newFilters.filters[filterBy] = priceValues;
         }
        
         setMyFilters(newFilters);
     };

const styles = {
  container: {
    display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
    padding: "10px",
    margin: "10px",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    fontSize: "25px",
  },
  icon: {
    width: "100%",
    maxWidth: "400px",
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "16px",
  },
};

const styles2 = {
  container: {
    left: "30px", /* Espace depuis la droite */
    display: "flex",
    gap: "10px",
    // margin: "60px",
    padding:'20px'
  },
  base: {
    cursor: "pointer",
    padding: "1px 4px",
    borderRadius: "5px",
    fontWeight: "bold",
    transition: "background-color 0.3s, color 0.3s",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    margin: "5px",
  },
  active: {
    backgroundColor: "#F5F5F5", // Light red
    border: "4px solid #000000",
    color: "#d32f2f", // Darker red
  },
  unActive: {
    backgroundColor: "#DCDCDC", // Dark red
    border: "1px solid #708090",
    color: "#000000",
  },
};

const btnNotOk = (a)=>{
  if(a==='customer' || a==='seller' || a==='provider'){
      return false 
  }
  return true
}
const btnNotOk2 = (a)=>{
  if(a==='customer'){
      return false 
  }
  return true
}

const btnOrtherUser = ()=>{
    setPageTeam(true)
    setPageProd(false)
    setPageShop(false)
}

const btnShopUser = ()=>{
    setPageTeam(false)
    setPageProd(false)
    setPageShop(true)
}

const btnShopPromo = (s=false, usId = null, prId= null, t = "")=>{

  setSowPromoUsPr(s)
  // setTitle()
  if(s){
    setTitle(t)
    setpagePromoUsPr({
      user_id: usId,
      prod_id: prId 
    })
  }else{
  setTitle("")
  setpagePromoUsPr({
    user_id: usId,
    prod_id: prId 
  })
}
}



      const btnCardUser = ()=>{
        return <div
        style={{...styles.container}}
        >
             {btnNotOk(getFilterOurTeam.roleName) && <span style={{
                  ...styles2.base,
                  ...styles2.unActive,
                //   ...(getFilterOurTeam.asc === "asc" ? styles2.active : {}),
                }}
                 onClick={btnOrtherUser}
                 >
                <FaUsersBetweenLines />
                </span>}

                {btnNotOk2(getFilterOurTeam.roleName) &&  <> 
               
                <span
                  style={{
                    ...styles2.base,
                    ...styles2.unActive,
                    // ...(getFilterOurTeam.asc === "desc" ? styles2.active : {}),
                  }}
                  onClick={btnShopUser}
                 >
                <FaStore />
                </span> 
                <span
                  style={{
                    ...styles2.base,
                    ...styles2.unActive,
                    ...(getFilterOurTeam.asc === "desc" ? styles2.active : {}),
                  }}
                 onClick={()=>btnShopPromo(true, getValidId(getFilterOurTeam.userID,  userInfo._id), null, refShopName)}
                 >{__elakayText("t004", "promo")}</span>
                </>}
                </div> 
      }

      const MarketplacePage = (infoSource) => {
        let marketplaceContent = infoSource.laguangeElakay('admAssPage', infoSource.languageAPI)
        return (
          <div
          // className="content"
          >
            <div className="aa-introduction">
              
              {marketplaceContent?.map((section, index) => (
                <section key={index}>
                  <h2>{section.title}</h2>
                  {section.text?.map((paragraph, idx) => (
                    <p key={idx} dangerouslySetInnerHTML={{ __html: paragraph }}></p>
                  ))}
                  {section.list?.length > 0 && (
                    <ul>
                      {section.list?.map((item, id) => (
                        <li key={id}>{item}</li>
                      ))}
                    </ul>
                  )}
                </section>
              ))}
              <button type="button" onClick={()=>setConditionsRole(true)} className="btn btn-outline-primary">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t001}</button>
            </div>
            <UserExitActAss
                      showProposition = {showConditionsRole}
                      setShowProposition = {setConditionsRole}
                     infoSource={infoSource}
                      userActiveRole = {userRole}
                      token={token}
                  
                  />
          </div>
        );
      };

const loadAllMyUserRef = (filTeam = getFilterOurTeam)=>{
  AllMyUserReF(token, filTeam).then(data => {
              if (data.error) {
                  } else {
                    setUseTeam(data)
                    setSowFilterOurTeam(false)  
              // const timer = setTimeout(() => {
              //   scrollToParagraph(divUSserTeam);
              // }, 400);
              // return () => clearTimeout(timer);
                  }
              })
}

    const loadMore = () => {
        let toSkip = getFilterOurTeam.skip + getFilterOurTeam.limit;
         getFilterOurTeam.skip = toSkip  
          scrollToParagraph(divUSserTeam)
           AllMyUserReF(token, getFilterOurTeam).then(data => {
              if (data.error) {
                  } else {
                    
                    setUseTeam(data)
                    setSowFilterOurTeam(false)  
                  }
              })
    
    };

    const loadMore0 = () => {
        let toSkip = getFilterOurTeam.skip - getFilterOurTeam.limit;

             scrollToParagraph(divUSserTeam)
        getFilterOurTeam.skip = toSkip  
      AllMyUserReF(token, getFilterOurTeam).then(data => {
              if (data.error) {
                  } else {
                    setUseTeam(data)
                    setSowFilterOurTeam(false)  
                  }
              })
    
    };

  const copyToClipboard = (jsonData) => {
    const jsonStr = JSON.stringify(jsonData, null, 2);
    navigator.clipboard.writeText(jsonData).then(() => {
      // alert('JSON copié dans le presse-papiers!');
      setShowAlert(true)
      setMessagetext("JSON copié dans le presse-papiers!")
    }).catch((err) => {
      console.error('Erreur lors de la copie : ', err);
    });
  };
    const copyImageToClipboard = async () => {
        try {
          // Accéder à l'élément <img> référencé
          const imgElement = imageRef.current;
    
          // Créer un canvas temporaire pour dessiner l'image
          const canvas = document.createElement('canvas');
             if (!canvas) {
          // alert('Canvas non trouvé.');
          setShowAlert(true)
          setMessagetext('Canvas non trouvé.')
          return;
        }
          canvas.width = imgElement.width;
          canvas.height = imgElement.height;
    
          // Dessiner l'image sur le canvas
          const ctx = canvas.getContext('2d');
          ctx.drawImage(imgElement, 0, 0);

          // Convertir le canvas en Blob
          const blob = await new Promise((resolve) =>
            canvas.toBlob(resolve, 'image/png')
          );
    
          // Copier l'image (Blob) dans le presse-papier
          await navigator.clipboard.write([
            new ClipboardItem({
              [blob.type]: blob,
            }),
          ]);
    
          // alert('Image copiée dans le presse-papier !');
          setShowAlert(true)
          setMessagetext('Image copiée dans le presse-papier !')
        } catch (error) {
          console.error('Erreur lors de la copie de l\'image :', error);
        }
      };

      const downloadImage = async () => {
        try {
          // Accéder à l'élément <img>
          const imgElement = imageRef.current;
          const canvas = document.createElement('canvas');
            if (!canvas) {
                //  alert('Canvas non trouvé.');
                 setShowAlert(true)
                 setMessagetext('Canvas non trouvé.')
                    return;
                        }
        canvas.width = imgElement.width;
        canvas.height = imgElement.height;
        const ctx = canvas.getContext('2d');
          ctx.drawImage(imgElement, 0, 0);
          // Créer un lien temporaire pour le téléchargement
          const url = canvas.toDataURL('image/png');
          const link = document.createElement('a');
          link.href = url; // URL de l'image (source de l'image)
          link.download = 'downloaded-image.png'; // Nom du fichier téléchargé
          link.click(); // Déclencher le téléchargement
    
          // alert('Image téléchargée avec succès !');
          setShowAlert(true)
          setMessagetext('Image téléchargée avec succès !')
        } catch (error) {
          console.error('Erreur lors du téléchargement de l\'image :', error);
        }
      };
   const handleChange = () => event => {
    const value = event.target.value;
    setNbrDays(value)
};
const handleChange1 = () => event => {
    const value = event.target.value;
    setTitle(value)
};


const handleSelPromo = (event) => {
    if (!token) return;

    const value = event.target.value;
       setSelectedPromoId(value);
    let getProm = {};
    let newUrl = ELAKAY_SITE_URL;

    if (value !== "") {
        const list = infoSource?.getPubToken || [];

        getProm = list.find(item => item._id === value);

        if (getProm?.token) {
            newUrl = buildPromoUrl(getProm);
        }
    }

    setTitle("");
    setPromoInfo(getProm);
    setUrl(newUrl);
};

const handleSelectPromo = (id) => {
  if (!token) return;

  setSelectedPromoId(id);

  let getProm = {};
  let newUrl = ELAKAY_SITE_URL;

  if (id) {
    const list = infoSource?.getPubToken || [];

    getProm = list.find(item => item._id === id);

    if (getProm?.token) {
      newUrl = buildPromoUrl(getProm);
    }
  }

  setTitle("");
  setPromoInfo(getProm);
  setUrl(newUrl);
}

const QR_API = (data, fg='000000', bg='ffffff') =>
  `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(data)}&color=${fg}&bgcolor=${bg}`;

// Seller/Provider Promotion Tokens go through /user-step?t= (auto-bound
// Agent, no Agent search step) instead of /userPUB/ (Simple Promotion —
// unchanged, still tags the visitor's browser via UserPUBToken).
const buildPromoUrl = (promo) =>
  promo?.promotionType === "seller" || promo?.promotionType === "provider"
    ? `${ELAKAY_SITE_URL}/user-step?t=${promo.token}`
    : promo?.type === 'EVENT_ROLE_TOKEN' ? `${ELAKAY_SITE_URL}/user-step?t=${encodeURIComponent(promo.token)}` : `${ELAKAY_SITE_URL}/userPUB/${promo.token}`;

// Evaluated per-call (not a module-level constant) so it reads
// __elakayInfoSource as of render time, after __setElakayInfoSource ran.
const promotionTypeBadge = (promotionType) => {
  if (promotionType === "seller") return __elakayText("t019", "Seller Token");
  if (promotionType === "provider") return __elakayText("t020", "Provider Token");
  return __elakayText("t021", "Simple Promotion");
};

const buildQrListFromPromo = (list = []) => {
  return list
    .filter(p => p?.token)
    .map((p, index) => {
      const value = buildPromoUrl(p);

      return {
        id: p._id || `q_${index}`,
        label: p.title || "Promo",
        value, // ✅ utilisé par QRCodeCanvas
        type: p.type,
        qrUrl: QR_API(value),
        // ✅ ajout demandé (image QR externe)
        url: QR_API(value)
      };
    });
};

const buildPosterList = (graphicList = []) => {


  const userPosters = graphicList.map((item, i) => ({
    id: item._id || `user_${i}`,
    label: item?.data?.poster?.label || `Poster ${i + 1}`,
    url: `${elakay_API}/graphic-promo/${item._id}/image`,
    isUserUpload: true,
    data: item.data,
    // createdAt: item.createdAt
  }));

  return {userPosters, graphicList};
};


const getMyQRCodePromo = () => {
  const list = infoSource?.getPubToken || [];

  const now = Date.now();

  const getProm = list.find(p =>
    p?.type === "MY_QR_CODE" &&
    new Date(p.expiryDate).getTime() > now
  ) || {};

  const newUrl = getProm?.token ? buildPromoUrl(getProm) : "";

  return { getProm, newUrl };
};

const setMyQRCodeState = () => {
  const { getProm, newUrl } = getMyQRCodePromo();

  setSelectedPromoId(getProm._id || "");
  setPromoInfo(getProm);
  setUrl(newUrl);
};

const handleDeletePromo = async () => {
  if (!selectedPromoId) return;

  const data = await deleteUserPubById(token, selectedPromoId);

  if (data?.error) {
    return;
  }

  setPubToken((prev) => prev.filter((item) => item._id !== selectedPromoId));
  setSelectedPromoId("");
  readUser(token)

};

const handleDeletePromoById = async (pubId) => {
  const data = await deleteUserPubById(token, pubId);

  if (data?.error || data?.success === false) {
    return;
  }

  setPubToken(data?.Pub || []);
  readUser(token)
  if (selectedPromoId === pubId) {
    setSelectedPromoId("");
  }
};

const btnCreatTokenPUB =()=>{
    if (loading) return;
    setLoading(true);
    creatTokenPUB(token, title, nbrDays, pagePromoUsPr.user_id,  pagePromoUsPr.prod_id, false, false, "PROMO", promotionType,
      promotionType === 'simple' ? {} : { [promotionType === 'seller' ? 'maxSeller' : 'maxProvider']: requestedPromotionMaximum }).then(data => {
        if (data?.error || data?.success === false) {
            setShowAlert(true); setMessagetext(tokenText(infoSource)(data?.code || "TOKEN_INVALID"));
        } else {

            setTitle("")
            setPromotionType("simple")
            let newUrl = buildPromoUrl(data)
            setUrl(newUrl)
            readUser(token)
        }
    }).catch(() => { setShowAlert(true); setMessagetext(tokenText(infoSource)("TOKEN_INVALID")); }).finally(() => setLoading(false))

}


const MyQRcodetoken_  =()=>{
    creatTokenPUB(token, title, nbrDays, pagePromoUsPr.user_id,  pagePromoUsPr.prod_id,  false, false).then(data => {
        if (data.error) {
        } else {
            
            setTitle("")
            let newUrl =`${ELAKAY_SITE_URL}/userPUB/${data.token}`
            setUrl(newUrl)
            readUser(token)
        }
    }) 

}

const MyQRcodetoken = () => {
  if (hasMyQRCode() || loading) return;
  setLoading(true);

  creatTokenPUB(
    token,
    title || tokenText(infoSource)("myQr"),
    qrDuration, // 365 ou 730
    pagePromoUsPr?.user_id,
    pagePromoUsPr?.prod_id,
    false,
    false,
    "MY_QR_CODE"
  ).then((data) => {
    if (!data || data.error || data.success === false) {
      setShowAlert(true); setMessagetext(tokenText(infoSource)(data?.code || "TOKEN_INVALID"));
      return;
    }

    setTitle("");
    setUrl(`${ELAKAY_SITE_URL}/userPUB/${data.token}`);
    readUser(token);
  }).catch(() => { setShowAlert(true); setMessagetext(tokenText(infoSource)("TOKEN_INVALID")); }).finally(() => setLoading(false));
};

const hasMyQRCode = () => {
    if (!infoSource?.getPubToken) return false;

    return infoSource.getPubToken.some(p =>
        p?.type === "MY_QR_CODE" &&
        new Date(p.expiryDate).getTime() > Date.now()
    );
};

      const formSelect_ = (array) => (
         <div className="form-group">
        <label className="text-muted">
            {/* select a promotion  */}
            {infoSource.language(infoSource, "label", "selPromo")}
         </label>
        <select onChange={handleSelPromo()} className="form-control">
        <option value={''} >{infoSource.language(infoSource, "label", "pleaseSelect")}</option>
        {array?.map((obj, j) =>{
         return <option value={j} >{obj.title}</option>
        })}
        </select>
    </div> 
        )

        // ══════════════════════════════════════════════
// ICÔNES SVG inline — utilisées dans creatQRCode
// ══════════════════════════════════════════════

const EditIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 20h9"/>
        <path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4z"/>
    </svg>
);

const QRIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7"/>
        <rect x="14" y="3" width="7" height="7"/>
        <rect x="3" y="14" width="7" height="7"/>
        <path d="M14 14h3v3h-3zM17 17h3v3h-3z"/>
    </svg>
);

const TrashIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/>
    </svg>
);

const CopyIcon = () => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round">
        <rect x="9" y="9" width="13" height="13" rx="2"/>
        <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
    </svg>
);

const ImgIcon = () => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round">
        <rect x="8" y="2" width="8" height="4" rx="1"/>
        <path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2"/>
    </svg>
);

const DownIcon = () => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
        <polyline points="7 10 12 15 17 10"/>
        <line x1="12" y1="15" x2="12" y2="3"/>
    </svg>
);
        
// ══════════════════════════════════════════════
// formTimer
// ══════════════════════════════════════════════
const formTimer = () => (
    <div className="qr-timer-block">
        <div className="qr-timer-num">
            <span className="qr-timer-val">{nbrDays}</span>
            <span className="qr-timer-unit">
                {infoSource.language(infoSource, "label", "expDay")}
            </span>
        </div>
        <div className="qr-range-wrap">
            <Form.Control
                type="range" min="1" max="7" step="1"
                value={nbrDays > 0 ? nbrDays : 1}
                onChange={handleChange("nbrDays")}
            />
            <div className="qr-ticks">
                {[1,2,3,4,5,6,7].map(d => <span key={d}>{d}d</span>)}
            </div>
        </div>
    </div>
);

// ══════════════════════════════════════════════
// linkQRcode
// ══════════════════════════════════════════════
const linkQRcode = (url = ELAKAY_SITE_URL) => (
    <div className="qr-share-panel">
        <div className="qr-url-bar">{url}</div>
        <div className="qr-share-row">
            <div className="qr-share-btns">
                <button className="qr-act-btn" onClick={() => copyToClipboard(url)}>
                    <CopyIcon />
                    {infoSource.language(infoSource, "label", "copyLink")}
                </button>
                <button className="qr-act-btn" onClick={copyImageToClipboard}>
                    <ImgIcon />
                    {infoSource.language(infoSource, "label", "copyQrcode")}
                </button>
                <button className="qr-act-btn" onClick={downloadImage}>
                    <DownIcon />
                    {infoSource.language(infoSource, "label", "downloadQrCode")}
                </button>
            </div>
            <div className="qr-canvas-box">
                <QRCodeCanvas
                    ref={imageRef}
                    value={url}
                    size={110}
                    bgColor="#ffffff"
                    fgColor="#000000"
                    level="H"
                />
            </div>
        </div>
    </div>
);

// ══════════════════════════════════════════════
// formSelect
// ══════════════════════════════════════════════
const formSelect = (array = []) => (
    <div className="qr-manage">
        <div className="qr-sel-row">
            <select onChange={handleSelPromo} value={selectedPromoId || ""}>
                <option value="">
                    {infoSource.language(infoSource, "label", "pleaseSelect")}
                </option>
                {array.map(obj => (
                    <option key={obj._id} value={obj._id}>{obj.title}</option>
                ))}
            </select>
            <button className="qr-btn-del" disabled={!selectedPromoId}
                onClick={handleDeletePromo}>
                {infoSource.language(infoSource, "label", "delete")}
            </button>
        </div>
        <div className="qr-promo-list">
            {array.length === 0
                ? <div className="qr-empty">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t002}</div>
                : array.map(obj => (
                    <div key={obj._id} onClick={()=>handleSelectPromo(obj._id)} className={`qr-p-row ${selectedPromoId === obj._id ? 'sel' : ''}`}>
                        <div className="qr-p-dot" />
                        <span className="qr-p-name-group">
                            <span className="qr-p-name">{obj.title}</span>
                            <span className={`qr-p-type-badge qr-p-type-${obj?.promotionType || "simple"}`}>
                                {promotionTypeBadge(obj?.promotionType)}
                            </span>
                        </span>
                       {obj?.type !== "MY_QR_CODE" && (
                            <button className="qr-p-del" onClick={() => handleDeletePromoById(obj._id)}>×</button>
                        )}
                    </div>
                ))
            }
        </div>
    </div>
);

// ══════════════════════════════════════════════
// creatQRCode  — layout principal
// ══════════════════════════════════════════════
const creatQRCode_ = () => (
    <div className="qr-root">

        {/* ── Carte 1 : configuration ── */}
        <div className="qr-card">
            <div className="qr-card-header">
                <div className="qr-ch-icon info"><EditIcon /></div>
                <span className="qr-ch-title">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t003}</span>
            </div>
            <div className="qr-card-body">
                {formTimer()}
                <div>
                    <label className="qr-f-label">
                        {infoSource.language(infoSource, "label", "titlePromo")}
                    </label>
                    <div className="qr-input-group">
                        <input type="text" maxLength={60}
                            onChange={handleChange1()}
                            value={title}
                            placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t004} />
                        <span className="qr-char-hint">{title.length}/60</span>
                    </div>
                </div>
                <button className="qr-gen-btn"
                    disabled={loading || title === ""}
                    onClick={btnCreatTokenPUB}>
                    {infoSource.language(infoSource, "label", "creatLink")}
                </button>
            </div>
        </div>

        {/* ── Carte 2 : QR + partage ── */}
        <div className="qr-card">
            <div className="qr-card-header">
                <div className="qr-ch-icon success"><QRIcon /></div>
                <span className="qr-ch-title">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t005}</span>
                {promoInfo?.title && (
                    <div className="qr-active-pill">
                        <div className="qr-pill-dot" />
                        <span>{promoInfo.title}</span>
                    </div>
                )}
            </div>
            <div className="qr-card-body">
                {url
                    ? linkQRcode(url)
                    : <div className="qr-empty-qr">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t006}</div>
                }
            </div>
        </div>

        {/* ── Carte 3 : gestion promos ── */}
        {infoSource?.getPubToken && (
            <div className="qr-card">
                <div className="qr-card-header">
                    <div className="qr-ch-icon warn"><TrashIcon /></div>
                    <span className="qr-ch-title">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t007}</span>
                    <span className="qr-ch-badge">{infoSource.getPubToken.length}</span>
                </div>
                <div className="qr-card-body">
                    {formSelect(infoSource.getPubToken.filter(pub => pub.type !== 'EVENT_ROLE_TOKEN'))}
                </div>
            </div>
        )}
  <ImageCombiner />
  <BusinessCardCreator infoSource={infoSource} userInfo={userInfo} />
    </div>
);

// ══════════════════════════════════════════════
// creatQRCode  — layout principal
// ══════════════════════════════════════════════
const promoTabs = [
    { key: 'configure', label: __elakayText("t017", "Configure Promotion") },
    { key: 'qrDesigner', label: elakayAutoText("qrd_tab", "View QR Code & Designer") },
    { key: 'poster', label: __elakayText("t002", "My Poster Design") },
    { key: 'business', label: __elakayText("t003", "Business Card Creator") },
];

const creatQRCode = () => (
    <div className="qr-root">

        {/* ── Tabs ── */}
        <div className="aa-promo-tabs" aria-label={infoSource.language(infoSource, "label", "creProElakay")}>
            {promoTabs.map(t => (
                <button
                    key={t.key}
                    type="button"
                    className={`aa-promo-tab ${navigation.view === t.key ? "active" : ""}`}
                    aria-pressed={navigation.view === t.key}
                    onClick={() => navigateView(t.key)}
                >{t.label}</button>
            ))}
        </div>

        {navigation.view === 'configure' && (<div className="aa-configuration-grid">
        <RoleTokenOwnerPanel token={token} infoSource={infoSource} readUser={readUser} pubs={infoSource?.getPubToken || []} />

        {/* ── Carte 1 : configuration ── */}
        <div className="qr-card">
            <div className="qr-card-header">
                <div className="qr-ch-icon info"><EditIcon /></div>
                <span className="qr-ch-title">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t008}</span>
            </div>
            <div className="qr-card-body">
                {formTimer()}
                <div>
                    <label className="qr-f-label">
                        {infoSource.language(infoSource, "label", "titlePromo")}
                    </label>
                    <div className="qr-input-group">
                        <input type="text" maxLength={60}
                            onChange={handleChange1()}
                            value={title}
                            placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t009} />
                        <span className="qr-char-hint">{title.length}/60</span>
                    </div>
                </div>

                <div>
                    <label className="qr-f-label">
                        {__elakayText("t018", "Promotion Type")}
                    </label>
                    <div className="qr-switch-group">
                        {[
                            { value: "simple", label: __elakayText("t021", "Simple Promotion"), enabledKey: "simplePromotionEnabled" },
                            { value: "seller", label: __elakayText("t019", "Seller Promotion Token"), enabledKey: "sellerPromotionEnabled" },
                            { value: "provider", label: __elakayText("t020", "Provider Promotion Token"), enabledKey: "providerPromotionEnabled" },
                        ].map((option) => {
                            // Family can turn a type off in AnimationSettings -- missing
                            // key (legacy/no doc yet) defaults to enabled, same tolerance
                            // as the backend's getPromotionTokenSettings().
                            const isTypeEnabled = infoSource?.allSettings?.promotionTokenSettings?.[option.enabledKey] !== false;
                            return (
                                <label className={`qr-switch${isTypeEnabled ? "" : " qr-switch-disabled"}`} key={option.value}>
                                    <input
                                        type="radio"
                                        name="promotionType"
                                        checked={promotionType === option.value}
                                        disabled={!isTypeEnabled}
                                        onChange={() => setPromotionType(option.value)}
                                    />
                                    <span className="qr-slider"></span>
                                    <span className="qr-label">
                                        {option.label}
                                        {!isTypeEnabled && (
                                            <em className="qr-type-disabled-note">
                                                {__elakayText("t022", "Currently disabled")}
                                            </em>
                                        )}
                                    </span>
                                </label>
                            );
                        })}
                    </div>
                </div>

                {promotionType !== 'simple' && <label className="qr-f-label">{tokenText(infoSource)('maxUsers')}
                    <input className="form-control" type="number" min="1" max={promotionLimits?.[`${promotionType}MaximumUsers`]} step="1"
                        value={promotionMaximum || promotionLimits?.[`${promotionType}MaximumUsers`] || ''} disabled={loading || !promotionLimits}
                        onChange={event => setPromotionMaximum(event.target.value)} />
                </label>}
                <button className="qr-gen-btn"
                    disabled={loading || title === "" || promotionMaximumInvalid}
                    onClick={btnCreatTokenPUB}>
                    {infoSource.language(infoSource, "label", "creatLink")}
                </button>


            </div>
        </div>

        {/* ── Carte 2 : QR + partage ── */}
        <div className="qr-card">
            <div className="qr-card-header">
                <div className="qr-ch-icon success"><QRIcon /></div>
                <span className="qr-ch-title">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t010}</span>
                {promoInfo?.title && (
                    <div className="qr-active-pill">
                        <div className="qr-pill-dot" />
                        <span>{promoInfo.title}</span>
                    </div>
                )}
            </div>
            <div className="qr-card-body">
                {url
                    ? linkQRcode(url)
                    : <div className="qr-empty-qr">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t011}</div>
                }
            </div>
        </div>

        {/* ── Carte 3 : gestion promos ── */}
        {infoSource?.getPubToken && (
            <div className="qr-card">
                <div className="qr-card-header">
                    <div className="qr-ch-icon warn"><TrashIcon /></div>
                    <span className="qr-ch-title">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t012}</span>
                    <span className="qr-ch-badge">{infoSource.getPubToken.length}</span>
                </div>
                <div className="qr-card-body">
                    {formSelect(infoSource.getPubToken.filter(pub => pub.type !== 'EVENT_ROLE_TOKEN'))}
                </div>
            </div>
        )}

{!hasMyQRCode() && (

  <div className="qr-main-box">

    {/* Choix durée */}

    <div className="qr-switch-group">

      <label className="qr-switch">

        <input

          type="radio"

          name="qrDuration"

          checked={qrDuration === 365}

          onChange={() => setQrDuration(365)}

        />

        <span className="qr-slider"></span>

        <span className="qr-label">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t013}</span>

      </label>

      <label className="qr-switch">

        <input

          type="radio"

          name="qrDuration"

          checked={qrDuration === 730}

          onChange={() => setQrDuration(730)}

        />

        <span className="qr-slider"></span>

        <span className="qr-label">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t014}</span>

      </label>

    </div>

    {/* Bouton centré */}

    <div className="qr-btn-center">

      <button

        className="qr-gen-btn qr-unique-btn small"

        disabled={loading} onClick={() => MyQRcodetoken(qrDuration)}

      >{__elakayText("t001", "My QR Code")}</button>

    </div>

  </div>

)}
        {(Adminstrator() || Family()) && <GroupInvitationsAdmin />}
        </div>)}

        {/* ── QR Code Designer (saved designs reused in the Poster Creator) ── */}
        {navigation.view === 'qrDesigner' && (
            <div className="qr-card">
                <div className="qr-card-header">
                    <div className="qr-ch-icon info"><EditIcon /></div>
                    <span className="qr-ch-title">{elakayAutoText("qrd_tab", "View QR Code & Designer")}</span>
                </div>
                <div className="qr-card-body">
                    <QrCodeDesigner promoLinks={buildQrListFromPromo(infoSource?.getPubToken).map(q => ({ id: q.id, label: q.label, value: q.value }))} />
                </div>
            </div>
        )}

        {/* ── Poster Design ── */}
        {navigation.view === 'poster' && (
            <div className="qr-card">
                <div className="qr-card-header">
                    <div className="qr-ch-icon info"><EditIcon /></div>
                    <span className="qr-ch-title">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t015}</span>
                </div>

                <div className="qr-card-body">
                    <ImageCombiner DEFAULT_POSTERS = {buildPosterList(graphicList)?.userPosters} token={token} addUpdateGraphicPromo={addUpdateGraphicPromo}  DEFAULT_QRS={[...designedQrs, ...buildQrListFromPromo(infoSource?.getPubToken)]} url={url} selectedPromoId={selectedPromoId} promoInfo={promoInfo} infoSource={infoSource} getPubToken={infoSource?.getPubToken} />
                </div>
            </div>
        )}

        {/* ── Business Card Creator ── */}
        {navigation.view === 'business' && (
            <div className="qr-card">
                <div className="qr-card-header">
                    <div className="qr-ch-icon success"><EditIcon /></div>
                    <span className="qr-ch-title">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t016}</span>
                </div>

                <div className="qr-card-body">
                    <BusinessCardCreator  DEFAULT_QRS={buildQrListFromPromo(infoSource?.getPubToken)}  infoSource={infoSource} userInfo={userInfo} />
                </div>
            </div>
        )}


    </div>
);

const allUserteam =(array) => (
  <Row className="m-1" xs={1} lg={2}   style={{overflowY: "auto"}}>
       { array &&  array?.map((U,i)=>{
       return  <div className="col p-2" key={U._id || i}>
        <CardUSer
          userInfo={U}
          infoSource={infoSource}
         fullName={U.firstname + ' '+ U.lastname}
         email={U.email}
         nbrUser={U.nombreTeam}
         getFilterOurTeam = {getFilterOurTeam}
         setFilterOurTeam = {setFilterOurTeam}
         loadAllMyUserRef={loadAllMyUserRef}
         setFullName={setFullName}
         setRoleName={setRoleName}
         setPageTeam={setPageTeam}
         setPageProd={setPageProd}
         setPageShop={setPageShop}
         User_id = {U._id}
      />
      </div>
      })}

  </Row>
)

const groupeUserteam =  (
  <div>
 {getFilterOurTeam?.grpByrole &&  userTeam?.groupedByRole?.map((U,i)=>{
       return  <div className="col p-1" key={i}>
        <div className="m-0 mb-4" style={{backgroundColor: "WhiteSmoke"}}><h5 className="my-0 mx-1  p-1 fw-bold">
        {U._id}
            </h5></div>
            {allUserteam(U.users)}
      </div> })}
  </div>
)

const OnlyMe_MyTeaMUsesr = ()=>{
  if(getFilterOurTeam.scopeMode === 'all') return 'All Elakay Users'
  if(getFilterOurTeam.userID === userInfo._id || getFilterOurTeam.userID === ''){
    if(getFilterOurTeam.myUser){
    return "My Personal Team"

    }else{
      return "My Team and Associated Teams"
    }

  }else{
    return 'the Team of ' + ' ' +  getFullName + ' ' + ' as '+ ' ' +  getRolaName
  }

}

const CustomerVIewShop =()=>{
  return      <ShopUserView
   prices={prices}
  setLoading={setLoading}
  infoSource={infoSource}
  promoMaker={true}
  // readUser={readUser}
  // ShopName={}
  setRefShopName={setRefShopName}
  refShopName={refShopName}
  btnShopPromo={btnShopPromo}
  setFilterShop={setFilterShop}
  setCalFilShop={setCalFilShop}
  myFilters={myFilters}
  userID={getValidId(getFilterOurTeam.userID,  userInfo._id)}
 />
}


const UrUserView = ()=>{
    return <div
    // className="content"
    >
     {/* <div className="alert-info p-4" style={{  'overflow': 'auto', 'maxHeight' : "400px"}}>
         {formTimer()}
         {infoSource && infoSource.getPubToken && formSelect(infoSource.getPubToken.filter(pub => pub.type !== 'EVENT_ROLE_TOKEN'))}
    </div> */}
      <div className="aa-team-content">
             <h2 className="text-muted">
             {infoSource.language(infoSource, "label", "collBetTeam")}
      </h2>
     {pageTeam && <>


         {getFilterOurTeam.userID === userInfo._id || getFilterOurTeam.userID !='' && <div className="btn btn-dark btn-md py-1 rounded-4" onClick={()=>{setFilterOurTeam(filterlist); loadAllMyUserRef(filterlist); setFullName(null); setRoleName(null)} }>
                    {/* Filters */}
                    {infoSource.language(infoSource, "label", "compTeam")}
          </div>}
           <span className='h4'>{OnlyMe_MyTeaMUsesr()}</span>
      <div ref={divUSserTeam} >    
         <SearchBar 
           infoSource={infoSource}
           getFilterUserProd={getFilterOurTeam}
           setFilterUserProd ={setFilterOurTeam}
           setSowFilterOurTeam={setSowFilterOurTeam}
           showTable={showTable}
           setShowTable={setShowTable}
           loadAllMyUserRef={loadAllMyUserRef}
           getFilterOurTeam={getFilterOurTeam}
           setFilterOurTeam={setFilterOurTeam}
           Shop={false}
           />
      
      {
      showTable? 
      infoSource.userRole && userTeam.groupedByRole &&  <AdminSlotTable objt={{groupedByRole: userTeam.groupedByRole, userRole: infoSource.userRole}} infoSource={infoSource} />
      :
      <> 
      {!getFilterOurTeam.grpByrole && allUserteam(userTeam.paginatedResults)}
      {getFilterOurTeam.grpByrole && groupeUserteam}

        <ButtonPagination
                infoSource ={infoSource}
                size={10}
                skip={getFilterOurTeam.skip}
                limit={getFilterOurTeam.limit}
                siseProduct={userTeam.total}
                loadMore={loadMore}
                loadMore0={loadMore0}
                
            />
      </>
      }
 </div>
      </>}
{pageProd&& <>

</>}

{pageShop && <>

  <div> {btnCardUser()}</div>
  {/* <Filter_searchProductUser
  infoSource={infoSource}
  /> */}
  {CustomerVIewShop()}
</>}
       </div>


       </div>
 }
  
 const UrWallet = ()=>{
    return <div
    //  className="content"
     >
      <Associateincomedashboard
        infoSource={infoSource}
        incommeView={incommeView}
        setIncommeView={setIncommeView}
        my_Order_as_Seller={my_Order_as_Seller}
        my_Seller_Order={my_Seller_Order}
        my_Commision_Orders={my_Commision_Orders}
        my_Promo_Orders={my_Promo_Orders}
        getTotal={getTotal}
        inComeSeller={inComeSeller}
        prodFrTransaction={prodFrTransaction}
        elakayFrais={elakayFrais}
        elakayFraisJSON={elakayFraisJSON}
        totalFrais={totalFrais}
        calProfit={calProfit}
        ItemsOrder={ItemsOrder}
        Seller={Seller}
        Assoociate={Assoociate}
        incommeL={true}
        onDateRangeChange={handleChartDateRangeChange}
      />
       </div>
 }

 const OrderPromo = ()=>{
    return <PromotionSummary token={token} infoSource={infoSource}>
      <style>{associateIncomeStyles}</style>
      <div className="associate-income-dashboard">
        <div className="aid-container">
          <MyPromotionOrdersTable
            promoData={my_Promo_Orders}
            infoSource={infoSource}
          />
        </div>
      </div>
       </PromotionSummary>
 }

      const refAddUser =  {
        asc: 'asc',
        limit : 50,
        skip : 0,
        roleName: 'null',
        allUser: false,
        myUser: true,
        grpByrole : true,
        agr: 2,
        sortBy: 'createdAt',
        userID: '',
         search: ''
        ,pointsMode: ''
        ,minPoints: ''
        ,maxPoints: ''
        ,suspensionStatus: ''
        ,scopeMode: 'team'
      }

    const navigationItems = [
      { key: 'introduction', icon: <FaHome />, label: infoSource.language(infoSource, 'label', 'introduction') },
      { key: 'elakayPromo', icon: <FaGift />, label: infoSource.language(infoSource, 'label', 'creProElakay') },
      { key: 'usersAdd', icon: <FaUserPlus />, label: infoSource.language(infoSource, 'label', 'addUser'), onSelect: () => loadAllMyUserRef(refAddUser) },
      { key: 'usersView', icon: <FaUsers />, label: infoSource.language(infoSource, 'label', 'viewUser'), onSelect: () => loadAllMyUserRef() },
      { key: 'roleRequests', icon: <FaUser />, label: infoSource.laguangeElakay('roleChangeRequest', infoSource.languageAPI)?.assignedRequests || 'Role requests' },
      { key: 'wallet', icon: <FaWallet />, label: infoSource.laguangeElakay('frontElakayHardcodedText', infoSource.languageAPI).adminAssociate.t017 },
      { key: 'allOrderPromo', icon: <FaReceipt />, label: infoSource.language(infoSource, 'label', 'allOrdPromo') },
      ...(Family() ? [{ key: 'liveActivity', icon: <FaBroadcastTower />, label: elakayAutoText('h_live_nav', 'Live Activity') }] : [])
    ];

                const filterOurTeam = ()=>{
                  return <Modal
                  size="lg"
                  dialogClassName="aa-filter-modal"
                  show={showFilterOurTeam}
                  onHide={() => setSowFilterOurTeam(false)}
                  // dialogClassName="modal-90w"
                  aria-labelledby="example-custom-modal-styling-title"
                  centered
              >
                  <Modal.Header closeButton>
                      <Modal.Title id="example-custom-modal-styling-title">
                      <h2>
                          {/* {infoSource.language(infoSource, "label", "ordFilt")} */}
                          {infoSource.language(infoSource, "label", "userFilt")}
                          </h2>
                      </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                <FilterUserTeam
                 infoSource= {infoSource}
                getFilterOurTeam = {getFilterOurTeam}
                setFilterOurTeam = {setFilterOurTeam}
                loadAllMyUserRef={loadAllMyUserRef}
                setSowFilterOurTeam={setSowFilterOurTeam}
                filterlist={filterlist}
                setShowTable={setShowTable}
                />
          
                  </Modal.Body>
              </Modal>
          
              }

     

            const PromoUsPr = ()=>{
              return <Modal
              size="lg"
              show={showPromoUsPr}
              onHide={() => btnShopPromo()}
              // dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              centered
          >
              <Modal.Header closeButton>
                  <Modal.Title id="example-custom-modal-styling-title">
                  <h2>
                      {/* {infoSource.language(infoSource, "title", "ordFilt")} */}
                      {infoSource.language(infoSource, "label", "userFilt")}
                      </h2>
                  </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {creatQRCode()}
            
              </Modal.Body>
          </Modal>
      
          }
            
              
    const contentForm =(a)=>{
     if (a === 'elakayPromo') {
        return <div
        // className="content"
        >
           {creatQRCode()}
            </div>     
        }else if(a === 'allOrderPromo'){
            return OrderPromo() 
        }else if(a === 'wallet'){
            return  UrWallet()  
        }else if(a === 'liveActivity' && Family()){
            // Mounted only while this section is shown: leaving it unmounts
            // CommunityLive, which closes its stream and stops the monitors.
            return <CommunityLive />
        }else if(a === 'roleRequests'){
            return <AssociateRoleRequests infoSource={infoSource} />
        }else if(a === 'usersView'){
            return UrUserView()   
        }else if(a === 'usersAdd'){
         return <div
        //  className="content"
         >
         <AdminFamily 
         infoSource ={infoSource} 
         usel = {getPageBoo().usel} 
         selectRole ={selectRole} 
         setSelectRole={setSelectRole} 
         userTeam={userTeam}
         /> 
         </div>
      }else{
         return MarketplacePage(infoSource)
        }
        }

    return (
        <Layout
            infoSource ={infoSource}
            title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).adminAssociate.t018}
            description={elakayAutoText("h_41682905073222", "Node React E-commerce App")}
            className="container-fluid"
            filterShop={filterShop}
            setFilterShop={setFilterShop}
            handleFilters={ handleFilters}
            setMyFilters={setMyFilters}
            getCalFilShop={getCalFilShop}
            userShop= {true}
            loading={loading}
            SliderPunShow={false}
            {...infoSource?.allSettings?.layout}
        >
       <AssociateDashboardShell infoSource={infoSource} items={navigationItems} activeTab={navigation.tab} onSelect={navigateTab} contentRef={divContent}>
        {contentForm(navigation.tab === 'introduction' ? '' : navigation.tab)}
        {filterOurTeam()}
        {PromoUsPr()}

        <AlertPage
        showAlert={showAlert}
        setShowAlert={setShowAlert}
        messagetext={messagetext}
        />
    </AssociateDashboardShell>
        </Layout>
    );
};

export default Admin_associate;
